import { FC } from "react";
import { useRecoilValue } from "recoil";

import {
  FiltersActionsApply,
  LoaderMui,
  TopHeaderCalendar,
} from "@ryde/controls";
import {
  BulkUpdateFormDrawer,
  FinalSchemaService,
  PageHeader,
  PageHeaderFilters,
  TableSettingsDrawerWrapperGeneric,
} from "@ryde/layout";
import { PageHeaderContext } from "@ryde/redux";
import {
  IExtendableDto,
  isGlobalLoaderActiveSelector,
  RydeUiUnit,
} from "@ryde/shared";

import {
  BulkCloneFormBookingsDrawer,
  BulkOperationsBookingsDrawer,
} from "../drawers";
import { BookingCustomHeaderRight } from "../header";
import {
  BookingsFloatingMenuCalendar,
  BookingsFloatingMenuGrid,
  BookingsPanelTop,
} from "../panels";
import { BookingsPanelSwitchRoutes } from "../routes";
import { useBookingsPage } from "./hooks";

const entity: RydeUiUnit = "booking";

export const BookingsPageMain: FC = () => {
  const {
    bookingHeaderContextValue,
    mainTitle,
    tableDefsGeneric,
    tableSettingsDrawerOpened,
    pendingText,
    bulkOperationsDrawerOpened,
    isCalendarBookingView,
    bulkUpdateFormDrawerOpened,
    bulkCloneFormDrawerOpened,
    isPending,
  } = useBookingsPage();
  const isGlobalLoaderActive = useRecoilValue(isGlobalLoaderActiveSelector);
  const shouldShowPendingLoader = isPending && !isGlobalLoaderActive;
  return (
    <>
      <FinalSchemaService />
      <PageHeader
        mainTitle={mainTitle}
        topWidgetComponent={<TopHeaderCalendar entity={entity} />}
        bottomWidgetComponent={<BookingsPanelTop />}
        customRightComponent={<BookingCustomHeaderRight />}
      >
        <PageHeaderContext.Provider value={bookingHeaderContextValue}>
          <PageHeaderFilters Actions={<FiltersActionsApply />} />
        </PageHeaderContext.Provider>
      </PageHeader>

      <BookingsPanelSwitchRoutes tableDefs={tableDefsGeneric} />

      {tableSettingsDrawerOpened && (
        <TableSettingsDrawerWrapperGeneric<IExtendableDto>
          tableDefs={tableDefsGeneric}
        />
      )}
      {bulkOperationsDrawerOpened && <BulkOperationsBookingsDrawer />}
      {!isCalendarBookingView && <BookingsFloatingMenuGrid />}
      {isCalendarBookingView && <BookingsFloatingMenuCalendar />}
      {bulkUpdateFormDrawerOpened && <BulkUpdateFormDrawer />}
      {bulkCloneFormDrawerOpened && <BulkCloneFormBookingsDrawer />}
      {shouldShowPendingLoader && (
        <LoaderMui loading={true} text={pendingText} />
      )}
    </>
  );
};
